import { useViewport } from '@utils/responsive';
import {
    Container,
    Heading,
    Wrapper,
    ProductsWrapper,
    ProductDetails,
} from './styles';
import Image from 'next/image';
import Card from './card';
import { getImageBasePath } from '@utils/generics';

const products = [
    {
        title: 'Credit Shield Insurance',
        description:
            'ACKO Credit Shield Insurance has enabled partners like Lendingkart, MoneyTap, ZestMoney, and HDB Financial Services to keep their customers protected. This has in turn increased customer satisfaction and promoted brand loyalty.',
        points: [
            'Provides financial security',
            'Protects loan portfolio if the customer meets with any unforeseen situations',
            'Extends fixed hospicash payment to the customer in case of hospitalisation',
        ],
        image: '/images/shield.svg',
    },
    {
        title: 'GIG Insurance',
        description:
            'The first-of-its-kind insurance plan, ACKO GIG Insurance helps companies such as Swiggy, Zomato, Rapido, etc. in protecting their ground fleet with tailor-made covers.',
        points: [
            'Insures employees for personal accidents, death, illness, etc, with customisable plans',
            'Covers employees on their active working days.',
            'Cost-effective and pay-per-use insurance covers for drivers and ground fleet.',
        ],
        image: '/images/gigInsurance.svg',
    },
    {
        title: 'Travel Insurance',
        description:
            'For partners like Goibibo, RedBus, EaseMyTrip, OLA, and OYO, the ACKO Travel Insurance has enhanced customer experience with innovative services such as paperless claim filing and instant settlement.',
        points: [
            'Covers the costs and losses associated with travelling.',
            'Cutting-edge covers to secure all kinds of travel plans: from cab & bus rides, to hotel and flight bookings',
            'The travel insurance products have a commendable NPS of +90',
        ],
        image: '/images/travelInsurance.svg',
    },
];

const Products = () => {
    const { isMobile } = useViewport();

    return (
        <Wrapper>
            <Container>
                <Heading>ACKO Products</Heading>
                <ProductsWrapper>
                    {products?.map((product, i) => {
                        const { title, description, points, image } = product;
                        return (
                            <ProductDetails key={title}>
                                <Card
                                    title={title}
                                    description={description}
                                    points={points}
                                    order={i % 2 === 0 ? 1 : 2}
                                />
                                <Image
                                    height={isMobile ? '555px' : '350px'}
                                    width={isMobile ? '740px' : '465px'}
                                    src={getImageBasePath(image)}
                                    objectFit="cover"
                                />
                            </ProductDetails>
                        );
                    })}
                </ProductsWrapper>
            </Container>
        </Wrapper>
    );
};

export default Products;
